<!--eslint-disable-->
<template>
  <div class="pricingScheme ">
    <div class="box20"></div>
    <div class="b_white bor_radius_10">
      <div class="lin_75 f18 gray_3 pad30_l">
        批量调价
      </div>
      <div class="ps_main clear">
        <div class="clear">
          <span class="float-left lin_30 inlineblock w70 gray_3">货品</span>
          <div class="float-left ps_choose_goods lin_30">
            <el-radio v-model="price.goodsType" :label="31" @input="goodsTypeSelect">按单个货品</el-radio>
            <el-radio v-model="price.goodsType" :label="21" @input="goodsTypeSelect">按货品分组</el-radio>
            <el-radio v-model="price.goodsType" :label="11" @input="goodsTypeSelect">全部货品</el-radio>
          </div>
        </div>

        <div class="box20"></div>
        <div class="pad70_l">
          <div v-if="price.goodsType === 31">
            <div v-if="goodsPageList.length === 0" class="ps_appoint_goods">
              <div class="ps_add" @click="chooseGoods">
                <i class="el-icon-plus"></i>
                选择货品
              </div>
            </div>
            <div v-else class="ps_appoint_goods">
              <div class="ps_add" @click="chooseGoods">
                <i class="el-icon-plus"></i>
                切换货品
              </div>
            </div>
            <div class="box20"></div>
            <div class="appoint_goods_list">
              <ul class="clear">
                <li v-for="(item,index) in goodsPageList" :key="index">
                  <img class="float-left appoint_good_img" v-if="item.picUrl" :src="item.picUrl" alt="">
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="">
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{item.name}}</p>
                    <p class="f12 gray_6">规格：{{item.spec}}</p>
                    <p class="f12 gray_6">原价：¥{{item.originalPrice}}</p>
                  </div>
                </li>
              </ul>
            </div>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :hide-on-single-page="totalCount <= pageSize"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>

          <div v-if="price.goodsType === 21">
            <div class="clear">
              <div v-if="categoryShowList.length === 0" class="ps_add" @click="chooseCategory">
                <i class="el-icon-plus"></i>
                选择分组
              </div>
              <div v-else class="ps_add" @click="chooseCategory">
                <i class="el-icon-plus"></i>
                切换分组
              </div>
            </div>
            <div class="box20"></div>
            <div class="ps_classify_list">
              <ul class="clear">
                <span class="float-left lin_30 inlineblock w92 gray_3">货品分组名称</span>
                <li class="ellipsis" :alt="item.text" v-for="(item,index) in categoryShowList" :key="index">
                  <el-tooltip class="item" effect="dark" :content="item.text" placement="top">
                    <span>{{item.text}}</span>
                  </el-tooltip>
                </li>
              </ul>
            </div>
          </div>
          <div class="box50"></div>
        </div>

        <div class="clear">
          <span class="float-left lin_30 inlineblock w92 gray_3">涉及价格方案</span>
        </div>
        <div class="pad70_l">
          <!-- 按单个货品设置的方案 -->
          <el-table v-if="schemeList.length > 0 && price.goodsType == 31" :data="schemeList" @selection-change="customerSelect" row-key="targetId" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="所属价格方案" />
            <el-table-column prop="schemeTypeCn" label="类别" />
            <el-table-column show-overflow-tooltip prop="customerNameStr" label="客户信息" />
            <el-table-column show-overflow-tooltip prop="customerGroupStr" label="分组信息" />
            <el-table-column prop="schemePriceNow" label="修改前价格" />
            <el-table-column prop="schemePriceNew" label="修改后价格" />
          </el-table>

          <!-- 按货品分组或全部货品设置的方案 -->
          <el-table v-if="schemeList.length > 0 && price.goodsType != 31" :data="schemeList" @selection-change="customerSelect" row-key="targetId" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="所属价格方案" />
            <el-table-column prop="schemeTypeCn" label="类别" />
            <el-table-column show-overflow-tooltip prop="customerNameStr" label="客户信息" />
            <el-table-column show-overflow-tooltip prop="customerGroupStr" label="分组信息" />
            <el-table-column prop="schemePriceRateNow" label="修改前折扣" />
            <el-table-column prop="schemePriceRateNew" label="修改后折扣" />
          </el-table>
        </div>

        <div class="pad70_l" v-if="price.goodsType === 31">
          <div class="modify_price_wrap" v-if="goodsPageTotalList.length > 0">
            <p>批量修改价格</p>
            <div class="lin_30 mar10_b">
              <el-radio-group v-model="modifyPriceRadio">
                <el-radio :label="1">批量加减价格</el-radio>
                <el-radio :label="2">按折扣修改价格</el-radio>
              </el-radio-group>
            </div>
            <div class="lin_30 mar10_b clear" v-if="modifyPriceRadio === 1">
              <p class="float-left">
                <el-input-number class="mar5_lr" maxlength="10" :precision="precision" v-model="batch.price"></el-input-number> 元
              </p>
              <el-button class="float-left mar40_l modify_price_btn" type="primary" @click="batchConfirm(1)">确 定</el-button>
            </div>
            <div class="lin_30 mar10_b clear" v-if="modifyPriceRadio === 2">
              <p class="float-left">
                折扣价 <input class="mar5_lr" type="text" min="0" maxlength="10"
                              v-model="batch.rebate" @input="batch.rebate = formatPrice(batch.rebate,0)"/>%
              </p>
              <el-button class="float-left mar40_l modify_price_btn" type="primary" @click="batchConfirm(2)">确 定</el-button>
            </div>
          </div>
        </div>

        <div class="pad70_l" v-if="price.goodsType !== 31">
          <div class="modify_price_wrap" v-if="schemeList.length > 0">
            <p>批量修改价格</p>
            <span class="gray_3">价格设置</span>
            <span class="pad15_l gray_9">按原价<input type="text" min="0" maxlength="10" v-model="batch.rebate" @input="batch.rebate = formatPrice(batch.rebate,0)">%，进行售卖 </span>
            <el-button class="mar40_l modify_price_btn" type="primary" @click="batchConfirm(3)">确 定</el-button>
          </div>
        </div>

        <div class="box20"></div>
        <div class="ps_footer t_center">
          <span slot="footer" class="dialog-footer ">
          <el-button type="primary" :disabled="disabled" @click="priceSubmit">确 认</el-button>
          <el-button @click="priceCancel">取 消</el-button>
        </span>
        </div>
      </div>
    </div>
    <!--选择商品弹框-->
    <el-dialog
      title="选择货品"
      :visible.sync="chooseGoodVisible"
      :close-on-click-modal="false"
      width="945px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop">
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">货品名称</span>
          <div class="ps_search float-left">
            <el-input
              type="text"
              placeholder="请输入货品名称"
              v-model="searchGoods.name"
            >
            </el-input>
          </div>
          <div class="float-left client_pop_query" @click="getPriceGoodsList(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">货品分类</span>
          <div class="ps_search float-left">
            <el-select v-model="searchGoods.axis" placeholder="请选择货品分类" clearable>
              <el-option
                v-for="item in backgroundCategoryList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear appoint_goods_list">
          <div class="float-left client_list_all">
            <p class=" gray_3">本店货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item,index) in goodsDataList" :key="index"  @click="goodsDialogSelect(item)">
                  <img class="float-left appoint_good_img" v-if="item.picUrl" :src="item.picUrl" alt="">
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="">
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{item.name}}</p>
                    <p class="f12 gray_6">规格：{{item.spec}}</p>
                    <p class="f12 gray_6">原价：¥{{item.originalPrice}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p class=" gray_3">已选货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item,index) in goodsSelectList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectGoods(item)"></i>
                  <img class="float-left appoint_good_img" v-if="item.picUrl" :src="item.picUrl" alt="">
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="">
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{item.name}}</p>
                    <p class="f12 gray_6">规格：{{item.spec}}</p>
                    <p class="f12 gray_6">原价：¥{{item.originalPrice}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box20"></div>
      </div>
      <el-pagination
        background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="currentPage2"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount2">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="goodsDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="价格方案分组"
      :visible.sync="chooseCategoryVisible"
      :close-on-click-modal="false"
      width="390px"
      custom-class="chooseClassifyPop">
      <div>
        <ul class="clear">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">分组名称</span>
          <el-input class="w220"
                    type="text"
                    v-model="filterGoodsGroup"
                    placeholder="请输入分组名称" @input="filterGroup"></el-input>
        </ul>
        <ul class="clear mar10-t">
          <li v-for="(item,index) in categoryDataList" @click="categoryDialogSelect(item)"
              :key="index" :class="{chooseClassifyActive:item.isActive}">
            {{item.text}}
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="categoryDialogConfirm">确 认</el-button>
        <el-button @click="chooseCategoryVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      id: "", // 价格方案id
      shopId: "",
      price: {
        // 提交对象
        schemeType: 1, // 类别 1.按分组设置,2.按客户设置
        goodsType: 31, // '选择货品类型 11.全部货品,21.指定分类,31.指定货品
        schemeTypeList: [],
        memberPriceList: [],
      },
      schemeTypeArray: [
        { key: 1, value: "按分组设置" },
        { key: 2, value: "按客户设置" },
      ],
      goodsTypeArray: [
        { key: 11, value: "全部货品" },
        { key: 21, value: "指定分类" },
        { key: 31, value: "指定货品" },
      ],
      multipleSelection: [],

      groupShowList: [], // 分组 展示
      customerSelectList: [], // 客户选择 数据
      categoryShowList: [], // 分类 展示
      goodsPageList: [], // 商品 分页展示
      goodsPageTotalList: [], // 商品 分页总数据
      goodsSelectList: [], // 商品 选择

      categoryDataList: [], // 分类 接口获取
      categoryDataListAll: [], // 分类 接口获取
      backgroundCategoryList: [], // 后台分类 接口获取
      goodsDataList: [], // 商品 接口获取
      batch: {
        price: "",
        rebate: 100,
      },
      rebate: "",
      chooseGroupVisible: false,
      chooseClientVisible: false,
      chooseGoodVisible: false,
      batchEditorVisible: false,
      chooseCategoryVisible: false,
      searchCustomer: {
        name: "",
        phone: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
      },
      searchGoods: {
        name: "",
        axis: "",
        shopId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        status: "",
      },
      disabled: false,
      // 分页
      pageSize: 9,
      currentPage: 1,
      totalCount: 0,
      pageSize1: 6,
      currentPage1: 1,
      totalCount1: 0,
      pageSize2: 10,
      currentPage2: 1,
      totalCount2: 0,
      modifyPriceRadio: 1,
      schemeList: [],
      skuId: "",
      filterGoodsGroup: "",
      precision: 2, // 价格保留位数，默认2
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getShopDefault();
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {
    this.$nextTick(() => {});
  },
  // 监听器
  filters: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.localGoodsPageList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.localGoodsPageList();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getPriceGoodsList();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getPriceGoodsList();
    },
    // 本地分页
    localGoodsPageList() {
      const array = this.goodsPageTotalList || [];
      const pageNo = this.currentPage;
      const { pageSize } = this;
      const offset = (pageNo - 1) * pageSize;
      this.goodsPageList = offset + pageSize >= array.length ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
      this.totalCount = array.length;
      if (this.goodsPageList.length > 0) {
        this.precision = this.goodsPageList[0].goodsPriceDigit ? this.goodsPageList[0].goodsPriceDigit : "2";
      }
    },
    getShopDefault() {
      this.$store.dispatch("header/getShopDefault", {}).then((data) => {
        if (data && data.shopIdStr) {
          this.shopId = data.shopIdStr;
        }
      });
    },
    getCategory() {
      this.$store.dispatch("priceScheme/getCategory", this.$qs.stringify({})).then((data) => {
        if (data && data.categoryEntityList) {
          this.backgroundCategoryList = data.categoryEntityList;
        }
      });
    },
    // 店铺分类
    getShopCategory() {
      requestApi.post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/selShopCate`, {}).then((res) => {
        if (res.code !== 0 && res.code !== "0") {
          this.$message.warning(res.msg);
          return;
        }
        if (!res.data || res.data.length <= 0) {
          return;
        }
        const category = [];
        res.data.forEach((item) => {
          category.push({
            text: item.categoryNameStr,
            idStr: item.categoryIdStr,
          });
        });
        this.categoryDataList = category;
        this.categoryDataListAll = category;
      });
    },
    // 1搜索  2选择货品
    getPriceGoodsList(type) {
      const { searchGoods } = this;
      searchGoods.pageNum = this.currentPage2;
      searchGoods.pageSize = this.pageSize2;
      searchGoods.shopId = this.shopId;
      if (type === 1) {
        // 搜索
        searchGoods.pageNum = 1;
      }
      this.$store.dispatch("priceScheme/priceGoodsList", this.$qs.stringify(searchGoods)).then((data) => {
        const newData = data || {};
        this.goodsDataList = newData.memberPriceVoList || [];
        this.totalCount2 = newData.totalCount || 0;
        if (type === 2) {
          if (this.goodsDataList.length === 0) {
            this.$message.error("无货品数据,请添加货品");
            return;
          }
          this.chooseGoodVisible = true;
        }
      });
    },
    // 点击添加分类
    chooseCategory() {
      if (this.categoryDataListAll.length === 0) {
        this.$message.warning("暂无相关分组的价格方案");
        return;
      }
      this.chooseCategoryVisible = true;
    },
    // 分类选择事件
    categoryDialogSelect(clickCate) {
      this.categoryDataList.forEach((category) => {
        this.$set(category, "isActive", false);
      });
      this.$set(clickCate, "isActive", true);
      this.categoryShowList = [];
      this.categoryShowList.push(clickCate);
    },
    categoryDialogConfirm() {
      if (this.categoryDataList.length <= 0) {
        this.$message.warning("选择价格方案分组不存在");
        return;
      }
      let hadCheckCate = false;
      this.categoryDataList.forEach((cateData) => {
        if (cateData.isActive) {
          hadCheckCate = true;
        }
      });
      if (!hadCheckCate) {
        this.$message.warning("请选择价格方案分组");
        return;
      }
      this.getSchemeList();
      this.chooseCategoryVisible = false;
    },
    // 点击添加商品
    chooseGoods() {
      this.goodsSelectList = Array.from(this.goodsPageTotalList);
      this.getCategory();
      this.getPriceGoodsList(2);
    },
    // 商品选择事件
    goodsDialogSelect(goods) {
      this.$set(goods, "isActive", !goods.isActive);
      this.goodsSelectList = [];
      const assign = Object.assign({}, goods);
      this.goodsSelectList.push(assign);
      this.handGoodsPrice(this.goodsSelectList);
    },
    // 删除已选择的商品
    removeSelectGoods(goods) {
      this.goodsSelectList.splice(
        this.goodsSelectList.findIndex((item) => item.goodsId === goods.goodsId),
        1
      );
    },
    goodsDialogConfirm() {
      this.goodsPageTotalList = Array.from(this.goodsSelectList);
      this.localGoodsPageList();
      this.goodsDialogClose();
      this.getSchemeList();
    },

    customerSelect(val) {
      console.log("val", val);
      this.multipleSelection = val || [];
    },

    // 根据商品/分组查询方案
    getSchemeList() {
      this.schemeList = [];
      if (this.goodsPageList.length <= 0 && this.categoryDataList.length <= 0 && this.price.goodsType != 11) {
        return;
      }
      if (this.goodsPageList.length > 0) {
        this.skuId = this.goodsPageList[0].goodsId;
      }
      let goodsTypeValue = null;
      // 选中的方案分组
      if (this.categoryDataList.length > 0) {
        this.categoryDataList.forEach((cateData) => {
          if (cateData.isActive) {
            goodsTypeValue = cateData.idStr;
          }
        });
      }
      let goodsType = null;
      if (this.price.goodsType === 11) {
        goodsType = 11;
      }
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/selDtlList`, {
          skuId: this.skuId,
          goodsTypeValue: goodsTypeValue,
          goodsType: goodsType,
        })
        .then((res) => {
          loadingInstance1.close();
          if (res.code !== 0 && res.code !== "0") {
            this.$message.warning(res.msg);
            return;
          }
          if (!res.data || res.data.length <= 0) {
            if (this.price.goodsType === 21) {
              this.$message.warning("暂无相关分组的价格方案");
              return;
            }
            if (this.price.goodsType === 11) {
              this.$message.warning("暂无全部货品的价格方案");
              return;
            }
            this.$message.warning("暂无相关商品的价格方案");
            return;
          }
          this.schemeList = res.data;
          this.schemeList.forEach((scheme) => {
            if (scheme.schemePriceRateNow) {
              let schemePriceRateNow = scheme.schemePriceRateNow;
              scheme.schemePriceRateNow = "按原价" + schemePriceRateNow + "售卖";
              scheme.schemePriceRateNew = "按原价" + schemePriceRateNow + "售卖";
            }
          });
        });
    },
    // 删除商品
    removeGoods(goods) {
      this.goodsPageTotalList.splice(
        this.goodsPageTotalList.findIndex((item) => item.goodsId === goods.goodsId),
        1
      );
      this.localGoodsPageList();
    },
    goodsDialogClose() {
      this.searchGoods = {};
      this.currentPage2 = 1;
      this.chooseGoodVisible = false;
    },
    // 取消价格方案
    priceCancel() {
      window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme/list?appid=1&isShowTitle=1`;
    },
    // 批量修改价格
    batchConfirm(type) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择价格方案后再修改价格");
        return;
      }
      const { price, rebate } = this.batch;

      // 商品原价
      let skuOriginalPrice = 0;
      if (this.goodsPageList.length > 0) {
        const { originalPrice } = this.goodsPageList[0];
        skuOriginalPrice = originalPrice;
      }
      try {
        this.multipleSelection.forEach(function (item) {
          let schemeName = item.name;
          // 修改前价格
          let schemePriceNow = item.schemePriceNow;
          let customerNameStr = item.customerNameStr;
          // 按价格修改
          if (type === 1) {
            schemePriceNow = parseFloat(schemePriceNow) + parseFloat(price);
            if (schemePriceNow <= 0) {
              throw new Error("客户: " + customerNameStr + "的价格方案货品修改后价格不能小于0");
            }
            if (schemePriceNow * 100 >= parseFloat(skuOriginalPrice) * 100) {
              throw new Error("价格方案: " + schemeName + "金额不能大于等于原价");
            }
          }
          if (type === 2) {
            if (rebate <= 0) {
              throw new Error("客户: " + customerNameStr + "的价格方案货品修改后价格不能小于0");
            }
            let schemePriceNew = 100 * parseFloat(schemePriceNow) * parseFloat(rebate);
            if (schemePriceNew >= parseFloat(skuOriginalPrice) * 100 * 100) {
              throw new Error("价格方案: " + schemeName + "金额不能大于等于原价");
            }
          }
          if (type === 3) {
            if (rebate <= 0) {
              throw new Error("价格方案: " + schemeName + "货品修改后价格不能小于0");
            }
            if (rebate >= 100) {
              throw new Error("价格方案: " + schemeName + "金额不能大于等于原价");
            }
          }
        });
      } catch (e) {
        this.$message.warning(e.message);
        return;
      }
      this.multipleSelection.forEach(function (item) {
        // 修改前价格
        let schemePriceNow = item.schemePriceNow;
        // 按价格修改
        if (type === 1) {
          let schemePriceNew = Number((Number(schemePriceNow) + Number(price)).toFixed(10));
          item.schemePriceNew = schemePriceNew;
        }
        if (type === 2) {
          let schemePriceNew = 100 * parseFloat(schemePriceNow) * parseFloat(rebate);
          console.log("schemePriceNew: ", schemePriceNew);
          item.schemePriceNew = Math.round(schemePriceNew / 100) / 100;
        }
        if (type === 3) {
          item.schemePriceRateNew = "按原价" + rebate + "%售卖";
          item.schemePriceRateNewNum = rebate;
        }
      });
    },
    // 提价价格方案
    priceSubmit() {
      if (this.schemeList.length <= 0) {
        this.$message.warning("批量调价内容不能为空");
        return;
      }

      // 校验是否变更
      let hadChangePrice = false;
      let hadChangeRate = false;
      this.schemeList.forEach((item) => {
        // 按商品设置
        if (this.price.goodsType === 31) {
          let schemePriceNowNum = parseFloat(item.schemePriceNow) * 100;
          let schemePriceNewNum = parseFloat(item.schemePriceNew) * 100;
          console.log("schemePriceNum: ", schemePriceNowNum, schemePriceNewNum);
          if (schemePriceNowNum != schemePriceNewNum) {
            hadChangePrice = true;
          }
        }
        if (this.price.goodsType === 11 || this.price.goodsType === 21) {
          if (item.schemePriceRateNow != item.schemePriceRateNew) {
            hadChangeRate = true;
          }
        }
      });
      if (!hadChangePrice && !hadChangeRate) {
        this.$message.warning("请选择价格方案调价后再保存");
        return;
      }

      this.disabled = true;
      let updateList = [];
      this.schemeList.forEach((item) => {
        let scheme = {};
        scheme.id = item.id;
        scheme.schemeType = item.schemeType;
        scheme.schemeType = item.schemeType;
        scheme.goodsTypeValue = item.goodsTypeValue;
        scheme.goodsTypeValue = item.goodsTypeValue;
        scheme.goodsType = item.goodsType;
        scheme.schemePriceRateNow = item.schemePriceRateNow;
        scheme.schemePriceRateNew = item.schemePriceRateNew;
        scheme.schemePriceRateNewNum = item.schemePriceRateNewNum;
        scheme.schemePriceNow = item.schemePriceNow;
        scheme.schemePriceNew = item.schemePriceNew;
        scheme.name = item.name;
        scheme.shopId = item.shopId;
        scheme.skuId = this.skuId;
        updateList.push(scheme);
      });
      this.$confirm("是否保存本次修改的内容，保存后对应价格方案将同步更新", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          requestApi
            .post(`${process.env.VUE_APP_APITAAS}sctrading/price/scheme/mj/updateBatch`, {
              schemeList: updateList,
              goodsType: this.price.goodsType,
            })
            .then((res) => {
              if (res.code !== 0 && res.code !== "0") {
                this.$message.warning(res.msg);
                return;
              }
              this.$message.success("保存成功");
              setTimeout(() => {
                window.location.href = `${process.env.VUE_APP_APP}v/mj/priceScheme/list?appid=1&isShowTitle=1`;
              }, 2000);
            });
        })
        .catch(() => {
          this.disabled = false;
        });
    },
    handGoodsPrice(memberPriceList) {
      // 格式化小数位数
      if (memberPriceList) {
        memberPriceList.forEach((item) => {
          const formatPrice = this.formatPrice(item.price, item.goodsPriceDigit);
          this.$set(item, "price", formatPrice);
        });
      }
    },
    // num 输入的数字 scale精确小数位数 negative true负数
    formatPrice(nums, scale, negative) {
      let value = `${nums}`;
      if (negative === true) {
        value = value.replace(/[^\-\d.]/g, "");
      } else {
        value = value.replace(/[^\d.]/g, "");
      }
      value = value.replace(/\\-{2,}/g, "-");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      if (scale === 0) {
        value = value.replace(".", "");
      }
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      return value;
    },
    numberValid(num, scales, greaterZeros) {
      let scale = scales;
      let greaterZero = greaterZeros;
      scale = scale || 2;
      if (greaterZero !== false) {
        greaterZero = true;
      }
      const format = this.numberFormat(num, scale);
      if (!format.msg) {
        if (greaterZero && format.num < 0) {
          format.msg = `请输入正确数字,最多${scale}位小数`;
        }
      }
      // 提示
      if (format.msg) {
        this.$message.error(format.msg);
      }
      return format.num;
    },
    numberFormat(nums, scales) {
      let scale = scales;
      let num = "";
      if (nums === 0 || nums) {
        num = nums.toString().trim();
      }
      scale = scale || 2; // 默认两位小数
      let message = "";
      const reg = /^[+-]?\d+(.\d+)?$/;
      if (reg.test(num)) {
        const lengthReg = new RegExp(`^[+-]?\\d{1,7}(.\\d{1,${scale}})?$`);
        if (!lengthReg.test(num)) {
          message = `请输入正确数字,最多${scale}位小数`;
          num = parseFloat(num).toFixed(scale);
        }
      } else {
        message = `请输入正确数字,最多${scale}位小数`;
        num = "";
      }
      return { num, msg: message };
    },
    // 选择 批量调价类型，按单个货品，分组，全部货品等
    goodsTypeSelect() {
      this.multipleSelection = [];
      this.schemeList = [];
      this.goodsPageList = [];
      this.categoryDataList = [];
      this.skuId = "";
      this.filterGoodsGroup = "";
      this.batch.rebate = 100;
      this.categoryShowList = [];
      if (this.price.goodsType === 21) {
        this.getShopCategory();
      }
      if (this.price.goodsType === 11) {
        this.getSchemeList();
      }
    },

    // 过滤筛选 商品分组
    filterGroup() {
      if (this.filterGoodsGroup === "") {
        this.categoryDataList = this.categoryDataListAll;
        return;
      }
      let filterGoodsGroupList = [];
      this.categoryDataListAll.forEach((item) => {
        console.log("是否包含：", item.text.indexOf(this.filterGoodsGroup));
        if (item.text.indexOf(this.filterGoodsGroup) >= 0) {
          filterGoodsGroupList.push(item);
        }
      });
      this.categoryDataList = filterGoodsGroupList;
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
@import "./index.scss";
</style>
<style>
.el-button--primary,
.el-button--primary:hover,
.el-button--primary:focus {
  background: #1286ff;
  border-color: #1286ff;
  color: #ffffff;
}
</style>
